import styled from 'styled-components';

export const TermsWrapper = styled.div<{ firstColor: string }>`
width: inherit;
 .note-title {
  font-size: 18px !important;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
 }
 .title {  
  font-size: 15px !important;
 }
 .item {
  color: ${props => props.firstColor || 'black'};
  font-size: 15px !important;
  cursor: pointer;
 }
 .highlight-label {
  background: rgb(220 226 231);
  color: ${props => props.firstColor || 'black'} !important;
  font-style: italic;
  font-size: 15px !important;
  font-weight: bold !important;
}
`